module.exports = __webpack_public_path__ + "static/media/7digital.9ae83711.jpg";